import { render, staticRenderFns } from "./YSearch.vue?vue&type=template&id=54323d4c&scoped=true&"
import script from "./YSearch.vue?vue&type=script&lang=js&"
export * from "./YSearch.vue?vue&type=script&lang=js&"
import style0 from "./YSearch.vue?vue&type=style&index=0&id=54323d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54323d4c",
  null
  
)

export default component.exports